module.exports = __webpack_public_path__ + "img/tougao.a66b6337.png";